import { Brand } from 'constants/brand';

export const SIGN_UP_LINK_CONFIG = {
  [Brand.FM]: `${process.env.REACT_APP_HUB_URL_FM}/en/Partnership/Introducing-brokers`,
  [Brand.GP]: `${process.env.REACT_APP_HUB_URL_GP}/partners`,
  [Brand.DAY1]: `${process.env.REACT_APP_HUB_URL_DAY1}/partner-with-day1`,
};
